import lt from "./lt.json";

export default lt;
